import React from "react";
import ReactDOM from "react-dom";
import MainScreen from "./MainScreen";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <MainScreen />
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
